export const FETCH_SURVEY = "fetchSurvey";
export const SUBMIT_SURVEY = "submitSurvey";
